export default "__VITE_ASSET__B5qDlu7O__"